import * as React from 'react';

const usePreviousValue = <T extends {}>(value: T): T | undefined => {
	const ref = React.useRef<T>();
	React.useEffect(() => {
		ref.current = value;
	});
	return ref.current;
};

export default usePreviousValue;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/customHooks/usePreviousValue.ts